import { styled } from '@mui/material';

export const ReportsVisitsSectionChartsContainer = styled('div')(
  ({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(2),
    gridAutoRows: '1fr',
  }),
);

export const ReportsVisitsSectionChartsSubContainer = styled('div')(
  ({ theme }) => ({
    display: 'grid',
    gridAutoFlow: 'column',
    gap: theme.spacing(2),
    gridAutoColumns: '1fr',
    minHeight: 342,
  }),
);

export const ReportsVisitsSectionChartsWrapperChart = styled('div')(
  ({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateRows: 'max-content 1fr',
  }),
);
